// Copyright Epic Games, Inc. All Rights Reserved.

import { LinearProgress } from "@material-ui/core";
import styled from "styled-components";

export const InstallationProgressBar = styled(LinearProgress)({
  width: "345px",
  height: "5px",
  margin: "14px 0",
});
